import { useSuspenseQuery } from '@tanstack/react-query';
import { useTenantedClient, useWhoami } from '@cotera/client/app/stores/org';
import { queryKeys } from '@cotera/client/app/hooks/query-cache-keys';
import { Assert } from '@cotera/utilities';
import type { SlackBotInstallationResponse } from '@cotera/api';

export const useSlackBotInstallation = (): SlackBotInstallationResponse => {
  const client = useTenantedClient();
  const orgId = useWhoami((s) => s.org.id);

  const { data } = useSuspenseQuery({
    queryKey: queryKeys.toolsV2.slackBotInstallation({ orgId }),
    queryFn: async () => {
      return Assert.assertOk(await client.toolsV2.getSlackBotInstallation({}));
    },
  });

  return data;
};
